import { apiSlice } from "../apiSlice";

export const teamsApiSlice = apiSlice.injectEndpoints({
  //   {
  //   "org_id": 0,
  //   "name": "string",
  //   "description": "string"
  // }
  endpoints: (builder) => ({
    getTeamsList: builder.query({
      query: ({ org_id }) => `/org/team/list/?org_id=${org_id}`,
      keepUnusedDataFor: 0,
    }),
    postTeam: builder.mutation({
      query: (teamData) => ({
        url: "/org/team/",
        method: "POST",
        body: teamData,
      }),
    }),
    putTeam: builder.mutation({
      query: (teamData) => ({
        url: "/org/team/",
        method: "PUT",
        body: teamData,
      }),
    }),
    deleteTeam: builder.mutation({
      query: (team_id) => ({
        url: `/org/team/?team_id=${team_id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  usePostTeamMutation,
  useGetTeamsListQuery,
  usePutTeamMutation,
  useDeleteTeamMutation,
} = teamsApiSlice;
